<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg bg-gray-50">
          <p
            v-if="clients.data.length === 0"
            class="m-5"
          >
            No clients to show
          </p>
          <template v-else>
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Company
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Client contact
                  </th>
                  <th
                    scope="col"
                    class="hidden md:table-cell px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Project m.
                  </th>
                  <th
                    scope="col"
                    class="hidden lg:table-cell px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Latest trip
                  </th>
                  <th
                    scope="col"
                    class="relative px-6 py-3"
                  >
                    <span class="sr-only">Go to client</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="client in clients.data"
                  class="bg-white"
                >
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{ client.name }}
                  </td>

                  <td
                    v-if="client.contact"
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    {{ client.contact.name }}
                  </td>
                  <td
                    v-else
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-400 italic"
                  >
                    No primary contact
                  </td>
                  <td
                    v-if="client.kam"
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    {{ client.kam.name }}
                  </td>
                  <td
                    v-else
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-400 italic"
                  >
                    No Key Account Manager
                  </td>
                  <td class="hidden lg:table-cell px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-200 text-gray-800">
                      N/A
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link
                      :href="route('clients.show', {id: client.id})"
                      class="text-indigo-600 hover:text-indigo-900"
                    >
                      Go to client
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination
              v-if="paginate"
              :model="clients"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination.vue';
import {Link} from '@inertiajs/vue3'

export default {
  name: 'ClientList',
  components: {
    Pagination,
      Link,
  },
  props: {
    clients: Array,
    paginate: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped>

</style>
